/** @format */

import React, { PropsWithChildren, useEffect } from "react";
import { AnalyticsProvider } from "use-analytics";
import { useDispatch } from "react-redux";

import { useAppSelector } from "../../app/hooks";
import CookiePopUp from "../cookie/cookiePopUp";
import { selectAllowCookies, setAllowCookies } from "../cookie/cookieSlice";
import analytics from "./analytics";

const AnalyticsProviderWithCookieBanner: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const allowCookies = useAppSelector(selectAllowCookies());

  useEffect(() => {
    if (window.localStorage.getItem("allowCookies") === "true") {
      dispatch(setAllowCookies(true));
    }
  }, [dispatch]);

  useEffect(() => {
    if (allowCookies) {
      analytics.plugins.enable(["google-analytics"]);
    }
  }, [allowCookies]);

  return (
    <AnalyticsProvider instance={analytics}>
      <>
        {!allowCookies && <CookiePopUp />}
        {children}
      </>
    </AnalyticsProvider>
  );
};

export default AnalyticsProviderWithCookieBanner;
